export const openLoginModal = (initialRedirectTo = window.location.href) => {
  let redirectTo = initialRedirectTo;

  if (
    window.Hivebrite.topic.whitelabelURL &&
    redirectTo.includes(window.Hivebrite.topic.whitelabelName)
  ) {
    const { pathname } = new URL(redirectTo);

    redirectTo = `/topics/${window.Hivebrite.topic.id}${pathname}`;
  }

  const element = document.getElementsByClassName('js-login')?.[0];
  const redirectInput = document.querySelector(
    '.login-form [name=redirect_to]',
  );

  if (redirectInput) {
    redirectInput.value = redirectTo;
  }

  if (element) {
    element.href = `${
      element.href.includes('?')
        ? element.href.substr(0, element.href.lastIndexOf('?'))
        : element.href
    }?redirect_to=${redirectTo}`;

    return element.click();
  }

  window.location = `/login?redirect_to=${redirectTo}`;
};
